<template>
  <div v-loading="loading" style="padding: 20px">
    <div v-if="itemList && itemList.length > 0">
      <template v-for="(item, i) in itemList">
        <div class="inventory-item">
          <warehouse-goods-info :goodsInfo="item.goodsInfo">
            <template slot="info-append">
              <div v-if="item.shelfLocation">
                <span style="margin-right: 5px">
                  货位编号: {{ item.shelfLocation }}
                </span>
              </div>
              <div v-if="item.costPrice">
                <span style="margin-right: 5px"> 成本单价: {{ item.costPrice }} </span>
              </div>
              <div v-if="item.displayZsmLabel">
                <span style="margin-right: 5px">
                  追溯码数: {{ item.displayZsmLabel }}
                </span>
              </div>
              <div>
                <div v-if="item.optRemark">
                  <div class="wordwrap">
                    备注信息:
                    <span class="item-remark">{{ item.optRemark }}</span>
                  </div>
                </div>
              </div>
            </template>
          </warehouse-goods-info>
          <div :class="'inventory-item-count' + optConsumeClassName(item)">
            <div>
              <span class="consume-label"> {{ optConsumeLabel(item) }}</span>
              <span class="count-label"> 数量: {{ item.goodsCount || 0 }} </span>
            </div>
          </div>
        </div>
      </template>
    </div>
    <el-empty v-else-if="!loading" :description="errorMsg" :image-size="100">
      <el-button v-if="errorMsg" @click="fetchList" size="small"> 重新加载 </el-button>
    </el-empty>
  </div>
</template>

<style lang="less" scoped>
.inventory-item-count {
  margin-top: 10px;
  margin-bottom: 20px;
  background-color: #f1f1f1;
  padding: 4px 10px;

  &.inventory-consume {
    .consume-label {
      color: #f78f52;
    }
  }

  .consume-label {
    font-weight: bolder;
    color: #b24eff;
  }

  .count-label {
    color: #000000;
    float: right;
  }
}

.inventory-item {
  .item-info {
    line-height: 20px;
    font-size: 14px;
  }

  .item-remark {
    font-weight: bolder;
    color: #e87431;
  }
}
</style>

<script>
import warehouseGoodsInfo from "../../../../components/business/warehouseGoodsInfo.vue";

export default {
  components: {
    warehouseGoodsInfo,
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    inInternal() {
      return this.tabName == "inventory-itemlist";
    },
    defaultParams() {
      return {
        storeGuid: this.pageParams.storeGuid,
        inventoryGuid: this.pageParams.guid,
      };
    },
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      itemList: null,
    };
  },
  methods: {
    optConsumeLabel(item) {
      if (!item) {
        return "";
      }
      if (item.optConsume == 1) {
        return "出库";
      }
      return "入库";
    },
    optConsumeClassName(item) {
      if (!item) {
        return "";
      }
      if (item.optConsume == 1) {
        return " inventory-consume";
      }
      return "";
    },
    fetchList() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.errorMsg = null;
      return this.requestApi("biz.warehouse.inventory.item.list", this.defaultParams)
        .then((resp) => {
          this.loading = false;
          this.itemList = (resp.data.list || []).map((item) => {
            let zsmList = this.toAny(item.goodsZsmList, []);
            if (zsmList instanceof Array && zsmList.length > 0) {
              item.displayZsmLabel = `${zsmList.length}个追溯码`;
            }
            return item;
          });
        })
        .catch((err) => {
          this.loading = false;
          this.errorMsg =
            (err && err.msg) || (err && err.message) || "连接服务器失败，请检查网络";
        });
    },
  },
  mounted() {
    this.fetchList();
  },
};
</script>
